import { SortableContainer } from 'react-sortable-hoc'
import { connect } from 'react-redux'
import SortableResponseItemUncategorized from './SortableResponseUncategorized'
import SortableResponseCategories from './SortableResponseCategories'

const SortableListContainer = SortableContainer((props) => {
  return (
    <div>
      {/* Response Categories */}
      <SortableResponseCategories
        searchText={props.searchText}
        preExpanded={props.preExpanded}
        isPrivate={props.isPrivate}
        onCategorizedResponsesSortEnd={props.onCategorizedResponsesSortEnd}
        setIsHoveringSection={props.setIsHoveringSection}
        hoveringSection={props.hoveringSection}
        response_categories={props.response_categories}
        hideAddDraftLink={props.hideAddDraftLink}
      />

      {/* Non-categized */}
      <ul onMouseEnter={() => props.setIsHoveringSection('category-0')} onMouseLeave={() => props.setIsHoveringSection('-')}>
        {props.allResponses.map((r, index) => (
          <SortableResponseItemUncategorized collection='sorting-responses' key={`item-${index}`} index={index} value={r} />
        ))}
      </ul>
    </div>
  )
})

const mapStateToProps = (state) => ({
  user: state.auth.user,
  isFree: state.company.company.isFree,
  isOnGracePeriod: state.company.company.isOnGracePeriod,
  is_subscribed: state.subscription.is_subscribed
})

export default connect(mapStateToProps, null)(SortableListContainer)
